import { IEstabelecimento } from "@/interfaces/IEstabelecimento";
import { createAction } from "@reduxjs/toolkit";

const sync = createAction(
  "ESTABELECIMENTO/sync",
  (items: IEstabelecimento[]) => ({
    payload: { items },
  })
);

export const estabelecimentoAction = { sync };
